import { render, staticRenderFns } from "./LucideIcon.vue?vue&type=template&id=4270ce09&"
import script from "./LucideIcon.vue?vue&type=script&lang=js&"
export * from "./LucideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports